import Selector from "./Default/SelectButtons";

export default function GenderSelector({ gender, setGender }) {
  const options = [
    { label: "Мужской" },
    { label: "Женский" }
  ];

  const optionsWithLabelAsValue = options.map(opt => ({
    value: opt.label,
    label: opt.label
  }));

  return <Selector options={optionsWithLabelAsValue} selected={gender} onChange={setGender} />;
}
